import Api from '@/utils/api'
import BasicConfig from '@/config/basic'

/** 分页查询推拿预约 GET /tuina/reservation */
export function getTuinaReservationList (query = {}) {
  return Api.get(`${BasicConfig.jDomain}/tuina/reservation`, {
    params: { ...query, axiosType: 'java' }
  })
}

/** 按技师分组的当日预约 GET /tuina/reservation/grouped */
export function getTuinaReservationGrouped (query = {}) {
  return Api.get(`${BasicConfig.jDomain}/tuina/reservation/grouped`, {
    params: { ...query, axiosType: 'java' }
  })
}

/** 推拿预约详情 GET /tuina/reservation/{id} */
export function getTuinaReservation (id) {
  return Api.get(`${BasicConfig.jDomain}/tuina/reservation/${id}`, {
    params: { axiosType: 'java' }
  })
}

/** 新建推拿预约 POST /tuina/reservation（JSON） */
export function createTuinaReservation (body = {}) {
  return Api.post(`${BasicConfig.jDomain}/tuina/reservation`, body, {
    axiosType: 'javaJson'
  })
}

/** 改约 PUT /tuina/reservation/{id}（JSON；id 在路径） */
export function updateTuinaReservation (id, body = {}) {
  return Api.put(`${BasicConfig.jDomain}/tuina/reservation/${id}`, body, {
    axiosType: 'javaJson'
  })
}

/** 取消预约 PUT /tuina/reservation/{id}/cancel（JSON；reason） */
export function cancelTuinaReservation (id, body = {}) {
  return Api.put(`${BasicConfig.jDomain}/tuina/reservation/${id}/cancel`, {
    reason: body.reason
  }, {
    axiosType: 'javaJson'
  })
}

/** 可预约时段 GET /tuina/reservation/slots */
export function getTuinaReservationSlots (query = {}) {
  return Api.get(`${BasicConfig.jDomain}/tuina/reservation/slots`, {
    params: { ...query, axiosType: 'java' }
  })
}

/** 分页查询推拿项目 GET /tuina/project */
export function getTuinaProjectList (query = {}) {
  return Api.get(`${BasicConfig.jDomain}/tuina/project`, {
    params: { ...query, axiosType: 'java' }
  })
}

/** 新建推拿项目 POST /tuina/project（multipart；cover 为图片文件） */
export function createTuinaProject (body = {}) {
  return Api.post(`${BasicConfig.jDomain}/tuina/project`, body, {
    axiosType: 'javaMultipart'
  })
}

/** 编辑推拿项目 PUT /tuina/project/{id}（multipart；cover 为新图片文件） */
export function updateTuinaProject (id, body = {}) {
  return Api.put(`${BasicConfig.jDomain}/tuina/project/${id}`, body, {
    axiosType: 'javaMultipart'
  })
}

/** 更新推拿项目状态 PUT /tuina/project/{id}/status（urlencoded；status） */
export function updateTuinaProjectStatus (id, body = {}) {
  return Api.put(`${BasicConfig.jDomain}/tuina/project/${id}/status`, body, {
    axiosType: 'java'
  })
}

/** 推拿项目下单 POST /tuina/purchase/order（JSON） */
export function createTuinaPurchaseOrder (body = {}) {
  return Api.post(`${BasicConfig.jDomain}/tuina/purchase/order`, body, {
    axiosType: 'javaJson'
  })
}

/** 分页查询推拿购买订单 GET /tuina/purchase/order */
export function getTuinaPurchaseOrderList (query = {}) {
  return Api.get(`${BasicConfig.jDomain}/tuina/purchase/order`, {
    params: { ...query, axiosType: 'java' }
  })
}

/** 推拿购买订单支付确认 POST /tuina/purchase/order/pay（JSON） */
export function payTuinaPurchaseOrder (body = {}) {
  return Api.post(`${BasicConfig.jDomain}/tuina/purchase/order/pay`, body, {
    axiosType: 'javaJson'
  })
}

/** 分页查询推拿会员 GET /tuina/member */
export function getTuinaMemberList (query = {}) {
  return Api.get(`${BasicConfig.jDomain}/tuina/member`, {
    params: { ...query, axiosType: 'java' }
  })
}

/** 新建推拿会员 POST /tuina/member（JSON） */
export function createTuinaMember (body = {}) {
  return Api.post(`${BasicConfig.jDomain}/tuina/member`, body, {
    axiosType: 'javaJson'
  })
}

/** 会员可服务项目与次数 GET /tuina/member/{id}/entitlements */
export function getTuinaMemberEntitlements (query = {}) {
  return Api.get(`${BasicConfig.jDomain}/tuina/member/${query.id}/entitlements`, {
    params: { axiosType: 'java' }
  })
}

/** 编辑推拿会员 PUT /tuina/member/{id}（JSON；id 在路径） */
export function updateTuinaMember (id, body = {}) {
  return Api.put(`${BasicConfig.jDomain}/tuina/member/${id}`, body, {
    axiosType: 'javaJson'
  })
}

/** 冻结推拿会员 DELETE /tuina/member/{id} */
export function freezeTuinaMember (id) {
  return Api.delete(`${BasicConfig.jDomain}/tuina/member/${id}`, {
    params: { axiosType: 'java' }
  })
}

/** 解冻推拿会员 PUT /tuina/member/{id}/unfreeze */
export function unfreezeTuinaMember (id) {
  return Api.put(`${BasicConfig.jDomain}/tuina/member/${id}/unfreeze`, {}, {
    axiosType: 'java'
  })
}

/** 新建推拿技师 POST /tuina/therapist（multipart；avatar 为图片文件） */
export function createTuinaTherapist (body = {}) {
  return Api.post(`${BasicConfig.jDomain}/tuina/therapist`, body, {
    axiosType: 'javaMultipart'
  })
}

/** 编辑推拿技师 PUT /tuina/therapist/{id}（multipart；avatar 为新图片文件） */
export function updateTuinaTherapist (id, body = {}) {
  return Api.put(`${BasicConfig.jDomain}/tuina/therapist/${id}`, body, {
    axiosType: 'javaMultipart'
  })
}

/** 在岗技师列表 GET /tuina/therapist/on-duty */
export function getTuinaTherapistOnDuty (query = {}) {
  return Api.get(`${BasicConfig.jDomain}/tuina/therapist/on-duty`, {
    params: { ...query, axiosType: 'java' }
  })
}

/** 技师详情 GET /tuina/therapist/{id} */
export function getTuinaTherapist (id) {
  return Api.get(`${BasicConfig.jDomain}/tuina/therapist/${id}`, {
    params: { axiosType: 'java' }
  })
}

/** 分页查询推拿班次 GET /tuina/shift */
export function getTuinaShiftList (query = {}) {
  return Api.get(`${BasicConfig.jDomain}/tuina/shift`, {
    params: { ...query, axiosType: 'java' }
  })
}

/** 班次下拉选项 GET /tuina/shift/options */
export function getTuinaShiftOptions (query = {}) {
  return Api.get(`${BasicConfig.jDomain}/tuina/shift/options`, {
    params: { ...query, axiosType: 'java' }
  })
}

/** 新建推拿班次 POST /tuina/shift（JSON） */
export function createTuinaShift (body = {}) {
  return Api.post(`${BasicConfig.jDomain}/tuina/shift`, body, {
    axiosType: 'javaJson'
  })
}

/** 编辑推拿班次 PUT /tuina/shift/{id}（JSON；路径和 body 都要 id） */
export function updateTuinaShift (id, body = {}) {
  return Api.put(`${BasicConfig.jDomain}/tuina/shift/${id}`, {
    ...body,
    id
  }, {
    axiosType: 'javaJson'
  })
}

/** 删除推拿班次 DELETE /tuina/shift/{id} */
export function deleteTuinaShift (id) {
  return Api.delete(`${BasicConfig.jDomain}/tuina/shift/${id}`, {
    params: { axiosType: 'java' }
  })
}

/** 按月获取技师排班（按技师分组）GET /tuina/therapist/schedule/grouped */
export function getTuinaTherapistScheduleGrouped (query = {}) {
  return Api.get(`${BasicConfig.jDomain}/tuina/therapist/schedule/grouped`, {
    params: { ...query, axiosType: 'java' }
  })
}

/** 导入技师排班 POST /tuina/therapist/schedule/import（multipart；file 为 Excel） */
export function importTuinaTherapistSchedule (body = {}) {
  return Api.post(`${BasicConfig.jDomain}/tuina/therapist/schedule/import`, body, {
    axiosType: 'javaMultipart'
  })
}

/** 新建技师排班 POST /tuina/therapist/schedule（JSON） */
export function createTuinaTherapistSchedule (body = {}) {
  return Api.post(`${BasicConfig.jDomain}/tuina/therapist/schedule`, body, {
    axiosType: 'javaJson'
  })
}

/** 删除技师排班 DELETE /tuina/therapist/schedule/{id} */
export function deleteTuinaTherapistSchedule (id) {
  return Api.delete(`${BasicConfig.jDomain}/tuina/therapist/schedule/${id}`, {
    params: { axiosType: 'java' }
  })
}
